import { z } from "zod";

import { creditReasonFieldsSchema } from "./credit-reason";

const WHOLE_NUMBER_PATTERN = /^\d+$/;

export const daysToAddSchema = z
  .string()
  .trim()
  .refine(
    (days) => WHOLE_NUMBER_PATTERN.test(days) && Number(days) >= 1,
    "Enter a whole number of days, 1 or more",
  )
  .transform(Number);

export const adjustRenewalDateFormSchema = z.object({
  days: daysToAddSchema,
  ...creditReasonFieldsSchema,
});

export type AdjustRenewalDateFormInput = z.input<
  typeof adjustRenewalDateFormSchema
>;

export type AdjustRenewalDateFormValues = z.output<
  typeof adjustRenewalDateFormSchema
>;
